import './assets/js/bootstrap'
import Vue from 'vue'
// import Landing from 'library/src/core/landing_v2'

// Components
import VueLanding from 'components/landing/VueLanding'
import VueMedia from 'components/media/VueMedia'

// Gvue Components
// import Hero from 'gvue/src/components/Hero'
import Zone from 'gvue/src/core/Zone'
import Heading from 'gvue/src/core/Heading'
import Paragraph from 'gvue/src/core/Paragraph'
import Cta from 'gvue/src/core/Cta'
import Visual from 'gvue/src/core/Visual'
import Popin from 'gvue/src/core/Popin'

// import App from './App'

// Vue.component('Hero', Hero)
Vue.component('Zone', Zone)
Vue.component('Heading', Heading)
Vue.component('Paragraph', Paragraph)
Vue.component('Cta', Cta)
Vue.component('Visual', Visual)
Vue.component('Popin', Popin)

Vue.use(VueMedia, {
    breakpoints: {
        S: 767,
        L: 1920,
        XL: Infinity
    },
    getImgSuffix (breakpoint) {
        return `_${breakpoint.name.toUpperCase()}`
    }
})

Vue.config.productionTip = false

export default ({ App, customLanding }) => {
    Vue.use(VueLanding, {
        project: customLanding,
        landing: 'm3-signaletique',
        skipMutationKeys: [
            'link',
            'link_mobile',
            'param',
            'tracking'
        ],
        additionalBrands: [],
        sectionTrackingLabels: {}
    })
    return new Vue({
        el: '#agilityApp',
        render: h => h(App)
    })
}
